<h1 class="title_4 txt-darkGray mb-5">{{ 'PROCESSES.HOUSING_CERTIFICATE.EXPIRED.TITLE' | translate }}</h1>
<p class="text_3 my-2"
   [innerHTML]="'PROCESSES.HOUSING_CERTIFICATE.EXPIRED.TEXT' |translate: {date: date | date:'longDate':'':locale}"></p>
<div class="position-sticky bg-white py-3 pb-lg-0 bottom_sticky d-flex gap-16">
  <button type="submit" class="btn btn-primary flex-grow-1 fw-bold" (click)="restartProcess()">
    {{ 'PROCESSES.HOUSING_CERTIFICATE.EXPIRED.BUTTON' | translate }}
  </button>
</div>
